<div class="header-bar">
  <h1>Regions</h1>
</div>
<div class="content-container">
  <p-table
    selectionMode="single"
    [value]="page.items"
    [lazy]="true"
    [rows]="10"
    [responsive]="true"
    [paginator]="true"
    rowHover="true"
    resizableColumns="true"
    [totalRecords]="page.total"
    (onLazyLoad)="onGridLazyLoad($event)"
    (onRowSelect)="onRowSelect($event)"
    [rowsPerPageOptions]="[10, 20, 50]"
    [pageLinks]="8"
    [(selection)]="selectedItem"
    *ngIf="isLoaded; else loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">Region Name</th>
        <th>Area Name</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr (dblclick)="onRowDblclick(item)" [pSelectableRow]="item">
        <td>{{ item.name }}</td>
        <td>{{ areaLookup(item.engineiusAreaId) }}</td>
      </tr>
    </ng-template>
  </p-table>

  <!-- DATATABLES DEPRECATED --
  <p-dataTabl selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true"
               [paginator]="true" rowHover="true" resizableColumns="true"
               [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)"
               (onRowDblclick)="onRowDblclick($event)" [rowsPerPageOptions]="[10,20,50]" [pageLinks]="8"
               [(selection)]="selectedItem" *ngIf="isLoaded; else loading">

    <p-column field="name" header="Region Name" [filter]="true" filterPlaceholder="Search contains"
              filterMatchMode="contains" [sortable]="tru" [editable]="false"></p-column>

    <p-column field="engineiusArea.name" header="Area Name" [filter]="true" filterPlaceholder="Search contains"
              filterMatchMode="contains" [sortable]="tru" [editable]="false">

      <ng-template pTemplate="body" let-item="rowData">
        {{ areaLookup(item.engineiusAreaId) }}
      </ng-template>

    </p-column>
  </p-dataTable>

  --->

  <div class="footerPanel ui-grid-row">
    <button
      type="button"
      class="btn-to-right"
      pButton
      (click)="onEditPostcodes()"
      label="Postcodes"
      icon="fa ui-icon-mode-edit"
      [disabled]="!selectedItem"
    ></button>
    <button
      type="button"
      class="btn-to-right"
      pButton
      (click)="onEdit()"
      label="Edit"
      icon="fa ui-icon-mode-edit"
      [disabled]="!selectedItem"
    ></button>
    <button
      type="button"
      class="btn-to-right"
      pButton
      icon="fa ui-icon-add"
      (click)="showDialogToAdd()"
      label="Add"
    ></button>
  </div>
</div>

<ng-template #loading>Loading...</ng-template>

<p-dialog
  #postcodeDialog
  header="Postcodes"
  [(visible)]="postcodesDialogVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '650px' }"
>
  <div class="ui-grid-row ui-grid-responsive ui-fluid">
    <div class="map-container">
      <p-tabView #tabviewPostcodes>
        <p-tabPanel header="UK" id="tabUKPostcodes" #tabUKPostcodes>
          <postcode-map-uk
            [ukDatas]="ukcodes"
            (UKCodeChange)="onUKCodesChanged($event)"
          ></postcode-map-uk>
        </p-tabPanel>
        <p-tabPanel header="London" id="tabLondonPostcodes" #tabLondonPostcodes>
          <postcode-map-london
            [datas]="londoncodes"
            (londonCodeChange)="onLondonCodesChanged($event)"
          ></postcode-map-london>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row" style="float: right">
    <button
      type="button"
      class="green-btn"
      pButton
      icon="fa ui-icon-check"
      (click)="dlgSavePostcodes()"
      label="Save"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Cancel"
      (click)="postcodesDialogVisible = false"
    ></button>
  </div>
</p-dialog>

<p-dialog
  header="Region"
  [(visible)]="displayDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <form [formGroup]="newERegionForm" (ngSubmit)="save()" autocomplete="off">
    <input type="hidden" name="id" formControlName="id" />

    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="name">Name</label></div>
        <div class="ui-g-8"><input pInputText id="name" formControlName="name" /></div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="name">Area</label></div>
        <div class="ui-g-8">
          <p-dropdown
            appendTo="body"
            placeholder="Select an area"
            [options]="eAreas"
            formControlName="engineiusAreaId"
            autoWidth="false"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div style="text-align: right">
      <button
        type="submit"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        label="Save"
        [disabled]="newERegionForm.value.name == ''"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="close()"
      ></button>
    </div>
  </form>
</p-dialog>
